/**
 * @generated SignedSource<<d9964615749b75f563f858d6c830a093>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Endpoint",
    "kind": "LinkedField",
    "name": "adjustEndpointQuantity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quantity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "step8OperatorInterfaceAdjustEndpointQuantityMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "step8OperatorInterfaceAdjustEndpointQuantityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "74ad4eef5de6ccd0e980c3fecb0aac2a",
    "id": null,
    "metadata": {},
    "name": "step8OperatorInterfaceAdjustEndpointQuantityMutation",
    "operationKind": "mutation",
    "text": "mutation step8OperatorInterfaceAdjustEndpointQuantityMutation(\n  $request: AdjustEndpointQuantityRequestInput\n) {\n  adjustEndpointQuantity(request: $request) {\n    id\n    quantity\n    version\n  }\n}\n"
  }
};
})();

node.hash = "a109ba82acc7f732cdaee358d4de3faf";

module.exports = node;
